import RunIf from './run-if';
import 'flickity/dist/flickity.pkgd';

export function init() {
	jQuery('#resources-carousel').flickity({
		groupCells: true,
		percentPosition: false,
		wrapAround: true,
		arrowShape: 'M100 50c0 4-3 7.2-7 7.2H24.4L48 80.7A7.2 7.2 0 1 1 38 90.8L2 55.1a7.2 7.2 0 0 1 0-10.2L37.9 9.2a7.2 7.2 0 1 1 10.1 10L24.4 42.9H93c4 0 7 3.2 7 7.2z'
	});
}

export function onLoad() {
	RunIf.isPage('single-pw_resource', init);
	RunIf.isPage('page-template-newsletter-archive', init);
}



// WEBPACK FOOTER //
// ./assets/scripts/resources.js